import React, { useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { providerPageWidth } from '../../constant';
import { ProviderTab, GoBackButton, Text } from '../../components/index';
import PersonalProfile from '../../components/Provider/Profile/PersonalProfile';
import HospitalInfo from '../../components/Provider/Hospital/HospitalInfo';
import PrimaryPatient from '../../components/Provider/Profile/PrimaryPatient';

const Profile = ({ history, location }) => {
    const { id } = useParams();
    const user = useSelector((state) => state.user);

    const [selectedTab, setSelectedTab] = useState(location?.state?.tab || 0);

    const tabsChangeHandler = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const isMy = useMemo(() => {
        if (user.staff.id === id) return true;

        return false;
    }, [user, id]);

    return (
        <div
            style={{
                padding: '41px 20px 50px',
                maxWidth: providerPageWidth,
                width: '100%',
            }}
        >
            {!id ? (
                <div style={{ display: 'flex', flexDirection: 'column', rowGap: '25px' }}>
                    {location.state?.prevPath && <GoBackButton $text onClick={history.goBack} />}
                    <Text $bold $fontSize="24px">
                        Add new provider
                    </Text>
                </div>
            ) : isMy ? (
                <Tabs
                    value={selectedTab}
                    onChange={tabsChangeHandler}
                    TabIndicatorProps={{ style: { background: 'transparent' } }}
                    variant="standard"
                >
                    <ProviderTab label="Personal Profile" $active={selectedTab === 0} />
                    <ProviderTab label="Counseling Service Details" $active={selectedTab === 1} />
                    {['Provider', 'Provider Admin'].includes(user.staff.staff_role.name) && (
                        <ProviderTab label="Primary Client" $active={selectedTab === 2} />
                    )}
                </Tabs>
            ) : (
                <GoBackButton $text onClick={history.goBack} />
            )}

            {selectedTab === 0 && <PersonalProfile />}
            {isMy && selectedTab === 1 && (
                <div style={{ paddingTop: '20px' }}>
                    <HospitalInfo />
                </div>
            )}
            {isMy && selectedTab === 2 && (
                <PrimaryPatient prevPath={location.pathname} prevTab={2} />
            )}
        </div>
    );
};

Profile.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
};

export default Profile;
